<script>
	export let id = null;
	export let label = null;
	export let value;
	export let disabled = null;
	export let maxlength = null;
	export let readonly = null;
	export let required = null;

	let className = $$props.class ? " " + $$props.class : "";
	let style = $$props.style ? $$props.style : null;

	$: valueLength = value ? value.length : 0;
</script>

<div class="char-tracker-wrap">
	{#if label !== null}<label for={id} class:isrequired={required}>{label}</label>{/if}
	{#if maxlength}
		<div class="char-tracker">
			<span class:limited={valueLength >= maxlength}>{valueLength}/{maxlength}</span>
		</div>
	{/if}
	<input
		{maxlength}
		{required}
		{disabled}
		{readonly}
		type="email"
		bind:value
		{id}
		class="form-control{className}"
		{style}
		on:change
	/>
</div>

